export const rocksStew = {
  id: "rocksStew",
  link: "/#/recipes/recipes/rocksStew",
  name: "Rock's Stew",
  cuisine: "Horneater-Alethi Fusion",
  summary:
    "Hearty, root-vegetable and seafood filled stew with a roasted red pepper base",
  inspiration: "Fish Solyanka",
  quantity: "4 servings",
  time: "2 hours",
  notes:
    "Since one of the earth cultures that inspired the Horneaters is Russian, I looked to examples of Russian seafood stew and found fish solyanka. I took it quite a different direction from there. I chose to use roasted red peppers for the base because I've decided not to use tomatoes for any of these recipes, and I wanted something that would bring color and flavor. Chili peppers appear to be available on Roshar, (The Sunlit Man ch 15) so red bell peppers should be available. I included burdock root as an analogue for longroot, since it was specifically mentioned as being included in one of Rock's stews. (Oathbringer ch 37) For the rest of the vegetables, I used things that I identified as being available on Roshar - turnips for curnips, butternut squash for tenem, and sweet potatoes. Rock used finger crabs in one of his stews, and shrimp seemed like a good choice for that. Finally, he mentioned adding crushed limm. (Oathbringer ch 37) We don't know anything about the flavor of limm, so rather than pick a real-world analogue I just made sure to include some ground spices.",
  quotes:
    '"You ever known any[one] who could turn down a warm fire and some stew at the end of a hard day?" (The Way of Kings ch 27)',
  image:
    "https://jozomby-public.s3.amazonaws.com/recipes/rocks-stew-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "bellPepper",
          display: "6 red bell peppers"
        },
        {
          item: "vegetableOil",
          display: "6 tbsp vegetable oil, divided"
        },
        {
          item: "onion",
          display: "2 onions, diced"
        },
        {
          item: "turnip",
          display: "1 lb turnips"
        },
        {
          item: "sweetPotato",
          display: "1 sweet potato"
        },
        {
          item: "butternutSquash",
          display: "1 1/2 cups butternut squash cubes"
        },
        {
          item: "burdockRoot",
          display: "12 inches burdock root"
        },
        {
          item: "salt",
          display: "2 1/2 tsp salt, divided"
        },
        {
          item: "scallops",
          display: "1/2 lb small scallops"
        },
        {
          item: "shrimp",
          display: "1 lb shrimp, peeled and deveined"
        },
        {
          item: "pickledCucumber",
          display: "1 medium dill pickle"
        },
        {
          item: "lemon",
          display: "2 tbsp lemon juice"
        },
        {
          item: "oysterSauce",
          display: "1 tbsp oyster sauce"
        },
        {
          item: "seafoodStock",
          display: "1 quart seafood stock"
        },
        {
          item: "water",
          display: "1/2 cup water"
        },
        {
          item: "bayLeaves",
          display: "2 bay leaves"
        },
        {
          item: "allspice",
          display: "1/2 tsp allspice"
        },
        {
          item: "dill",
          display: "1/2 tsp dill"
        },
        {
          item: "cumin",
          display: "1 tsp ground cumin"
        },
        {
          item: "carawaySeeds",
          display: "1 tsp caraway seeds"
        },
        {
          item: "garlicClove",
          display: "2 cloves garlic, minced"
        }
      ]
    }
  ],
  steps: [
    "Cut the peppers in half and remove stems and seeds. Place the peppers, cut sides down, on a baking sheet. Put the sheet on the highest rack in the oven and set to broil. Broil the peppers until the skins are mostly blackened. Remove from the oven and let cool 2 minutes. Place the peppers in a ziploc bag, seal, and set aside.",
    "While the peppers are broiling, put 1/4 cup vegetable oil in a stock pot over low heat. Add the onions and cook 45 minutes or until golden brown. You won't need to stir them very often at all.",
    "Once the peppers are in the bag and the onions are cooking, peel and chop the turnips, sweet potato, and squash into 1/2 to 3/4 inch cubes. Peel the burdock root and slice into thin rounds. Toss the vegetables with 2 tbsp vegetable oil and 1/2 tsp salt, then spread in a single layer on the baking sheet.",
    "Heat the oven to 425 degrees Fahrenheit, then return the baking sheet (with the vegetables on it) to the oven. Roast 20 minutes, stir the vegetables, and roast another 10 minutes. Remove from the oven and set aside.",
    "Remove the peppers from the bag and peel off and discard the skins. Place the peeled peppers in a food processor and process into a chunky liquid.",
    "Once the onions are golden brown, place the scallops in a single layer in the pot with the onions. Turn up the heat to medium and cook 2 minutes. Flip the scallops and cook until done. Remove the scallops from the pot, leaving the onions.",
    "Add the shrimp to the pot, cook and stir until cooked, then remove the shrimp, leaving the onions in the pot.",
    "Add the roasted vegetables to the pot. Mince the pickle, and add it to the pot, along with the lemon juice, processed peppers, oyster sauce, seafood stock, and 1/2 cup water. Add the bay leaves, allspice, dill, cumin, caraway seeds, 2 tsp salt, and garlic. Turn heat to medium high and bring to boil. Cover and reduce heat to simmer. Let simmer 10 minutes until vegetables are tender (burdock root will still have some crunch to it).",
    "Add the shrimp and scallops to the stew. Heat through, then remove bay leaves and serve."
  ]
}
